import { render, staticRenderFns } from "./tab-works.vue?vue&type=template&id=6e78bcfb&scoped=true"
import script from "./tab-works.vue?vue&type=script&lang=js"
export * from "./tab-works.vue?vue&type=script&lang=js"
import style0 from "./tab-works.vue?vue&type=style&index=0&id=6e78bcfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e78bcfb",
  null
  
)

export default component.exports